<template>
<footer>
  <a href="#" v-scroll-to="'#top'">
    <img class="ap_Logo" src="/img/audemars_piguet_monogrram.png" />
  </a>
  <div class="footer_Container">
    <p><a href="https://www.audemarspiguet.com">© 2020 Audemars Piguet</a></p>
  </div>
</footer>
</template>
<script>
export default {
  name: 'Footer',
  props: {
    navAvail: Boolean
  },
}
</script>
